import { render } from "./DCMMGuide.vue?vue&type=template&id=38053cc2&scoped=true"
import script from "./DCMMGuide.vue?vue&type=script&lang=js"
export * from "./DCMMGuide.vue?vue&type=script&lang=js"

import "./DCMMGuide.vue?vue&type=style&index=0&id=38053cc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38053cc2"]])

export default __exports__